import React from 'react';

import { Image } from 'src/components/atoms/Image';
import { Row } from 'src/styles/layout';
import { CSSVarTitle, SubTitle, Title } from 'src/styles/layout.styles';
import { trackBannerClick } from 'src/tracking/homepageTracking';
import { Image as ImageType } from 'src/types/Image';
import * as styles from './HomepageBanner.style';

export interface HomepageBannerProps {
  backgroundColor: string;
  image: ImageType;
  link: string;
  subtitle: string;
  title: string;
}

export const SUBTITLE_TESTID = 'homepage_banner__sub_title';

export interface Props extends HomepageBannerProps {
  sectionId: string;
}

export const HomepageBanner = ({
  sectionId,
  link,
  title,
  image,
  backgroundColor,
  subtitle,
}: Props) => {
  return (
    <a
      css={styles.BannerLink}
      href={link}
      onMouseDown={() => trackBannerClick({ sectionId, ctaText: title, link })}
    >
      <Row>
        {/* @ts-ignore*/}
        <Row.Column size={{ phone: 12, tablet: 6 }}>
          <div css={styles.BannerImage}>
            <Image src={image.desktop} />
            <Image src={image.mobile} />
          </div>
        </Row.Column>
        {/* @ts-ignore*/}
        <Row.Column size={{ phone: 12, tablet: 6 }}>
          <div
            css={styles.BannerHeading}
            style={{ '--bgColor': backgroundColor } as styles.CSSVarHeading}
          >
            <h3
              css={Title}
              data-testid="homepage_banner__title"
              data-negative-colours="true"
              style={{ '--uppercase': 'uppercase' } as CSSVarTitle}
            >
              {title}
            </h3>
            <p css={SubTitle} data-testid={SUBTITLE_TESTID} data-negative-colours="true">
              {subtitle}
              &nbsp;&raquo;
            </p>
          </div>
        </Row.Column>
      </Row>
    </a>
  );
};
